export class FieldConfig {
  name: string = "";
  displayName: string = "";
  isHidden: boolean = false;
  isRequired: boolean = true;

  _i18n?: Record<string, Record<string, string>>;

  constructor(name: string, displayName: string) {
    this.name = name;
    this.displayName = displayName;
  }
}
